// @flow

import type { InvoiceDocument } from './invoice-document'

export type InvoiceSummary = {
  date: ?Date,
  invoiceNumber: string,
  invoiceType: string,
  totalAmount: Object,
  invoiceDocuments: InvoiceDocument[]
}

const buildInvoiceSummary = (): InvoiceSummary => {
  return {
    date: null,
    invoiceNumber: '',
    invoiceType: '',
    totalAmount: {},
    invoiceDocuments: []
  }
}

export {
  buildInvoiceSummary
}



// WEBPACK FOOTER //
// ./src/types/invoice-summary.js